/* istanbul ignore file */
import logoDark from 'core/common/assets/images/logoNebulaDark.svg';
import logoWhite from 'core/common/assets/images/logoNebulaWhite.svg';
import logoBigDark from 'core/common/assets/images/nebulaDark.png';
import logoBigWhite from 'core/common/assets/images/nebulaLight.png';
import { useThemeContext } from 'core/theme/contexts';

export function useLogo() {
  const { isLightTheme } = useThemeContext();

  return {
    logoSrc: isLightTheme ? logoDark : logoWhite,
    logoSrcBig: isLightTheme ? logoBigDark : logoBigWhite,
  };
}
